import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './CharacterCounter.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const LIMITS = [
  { key: 'x', label: 'X (Twitter)', limit: 280 },
  { key: 'instagram_bio', label: 'Bio do Instagram', limit: 150 },
  { key: 'instagram_caption', label: 'Legenda do Instagram', limit: 2200 },
  { key: 'linkedin_bio', label: 'Título do LinkedIn', limit: 220 },
  { key: 'linkedin_post', label: 'Post do LinkedIn', limit: 3000 },
  { key: 'facebook_post', label: 'Post do Facebook', limit: 63206 },
  { key: 'tiktok_caption', label: 'Legenda do TikTok', limit: 2200 },
  { key: 'youtube_title', label: 'Título do YouTube', limit: 100 },
  { key: 'meta_description', label: 'Meta description (SEO)', limit: 160 },
]

const CharacterCounter = () => {
  useDocumentMeta({
    title: 'Contador de Caracteres para Redes Sociais | jarder.dev',
    description:
      'Veja quantos caracteres seu texto tem e compare com os limites ' +
      'de X, Instagram, LinkedIn e outras redes. Grátis.',
  })

  const [text, setText] = useState('')

  const length = text.length
  const words = useMemo(() => (text.trim() ? text.trim().split(/\s+/).length : 0), [text])

  const handleBlur = () => trackEvent('tool_generate', { tool: 'character_counter' })

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Contador de Caracteres para Redes Sociais</h1>
      <p className="tool-disclaimer">
        Digite seu texto e veja quanto espaço ainda tem em cada rede
        social.
      </p>

      <div className="tool-field">
        <label htmlFor="text">Seu texto</label>
        <textarea
          id="text"
          rows="6"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={handleBlur}
        />
      </div>

      <p className="tool-import-hint">
        {length} caracteres · {words} palavras
      </p>

      <ul className="tool-list" style={{ marginTop: 16 }}>
        {LIMITS.map(({ key, label, limit }) => {
          const remaining = limit - length
          const over = remaining < 0
          return (
            <li key={key} className="character-counter-row">
              <span>{label}</span>
              <span className={over ? 'character-counter-over' : 'character-counter-ok'}>
                {length} / {limit}
                {over && ` (${Math.abs(remaining)} acima do limite)`}
              </span>
            </li>
          )
        })}
      </ul>

      <div className="tool-info-section">
        <h2>Por que os limites variam tanto</h2>
        <p>
          Cada rede social define seu próprio limite de caracteres para
          manter os textos legíveis no feed: o X (antigo Twitter) é o
          mais restritivo (280), enquanto legendas do Instagram e posts
          do LinkedIn toleram textos bem mais longos. Passar do limite
          normalmente corta o texto ("truncamento") ou impede a
          publicação, dependendo da plataforma.
        </p>
        <p>
          A contagem de palavras ajuda a estimar o tempo de leitura, útil
          para roteiros de vídeo, legendas e descrições de SEO (como a
          meta description, que o Google costuma exibir até ~160
          caracteres).
        </p>
      </div>
    </div>
  )
}

export default CharacterCounter
